export default "__VITE_ASSET__KmqHu$Um__"